export default __webpack_public_path__ + "static/media/loading-capsule-animation-gif.100375fd.gif";